import { Route, Routes } from "react-router-dom";
import { Error404 } from 'pages';
import EquipmentAlertViewMonitoring from "pages/monitoring/equipment-alert-view";
import EquipmentAlertHistoryTrackingMonitoring from "pages/monitoring/equipment-alert-history-tracking";

export default function MonitoringEquipmentAlertHistoryTrackingRoutes(props) {

    return (
        <Routes>
            <Route path="/*">
                <Route path="/*" element={ <EquipmentAlertHistoryTrackingMonitoring /> }/>
                
                <Route path=":id" element={ <EquipmentAlertViewMonitoring /> }/>
               
                <Route path="*" element={ <Error404/> }/>
            </Route>
        </Routes>
    );
}